function renderModel(env) {
    if (env.three.status === 'model') {
        return;
    }
    for (let flowerObject of env.objects.flowers) {
        if (!flowerObject.modelMesh.flowerMesh) {
            continue;
        }
        if (!flowerObject.params.visible) {
            flowerObject.clearReal(false);
            flowerObject.modelMesh.flowerMesh.visible = false;
            if (flowerObject.modelMesh.stemMesh) {
                flowerObject.modelMesh.stemMesh.visible = false;
            }
            if (flowerObject.modelMesh.touchHelperMesh) {
                flowerObject.modelMesh.touchHelperMesh.visible = false;
            }
            continue;
        }
        let val = true;
        if (env.params.showId) {
            val = false;
            if (env.params.showId === flowerObject.id) {
                val = true;
            }
        }
        flowerObject.clearReal(val);
    }
    env.three.status = 'model'
}

export default renderModel;
